import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import TaskIcon from '@mui/icons-material/Task';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import WebhookIcon from '@mui/icons-material/Webhook';
import StyleIcon from '@mui/icons-material/Style';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import '../amcFollowUp/amcFollowup.css';
import AssessmentIcon from '@mui/icons-material/Assessment';

const SideMenus = ({ openMenuId, setOpenMenuId, onClose }) => {
  const navigate = useNavigate();

  const vLoginData = useSelector(
    createSelector(
      (state) => state.user,
      (user) => user
    )
  );
  const vKern = useSelector((state) => state.user.kern);
  const selectAmcMenu = createSelector(
    (state) => state.user?.menu || [], // Safely handle undefined state
    (menu) => menu
  );
  const amcMenu = useSelector(selectAmcMenu);

  const isAmcFollowupVisible = amcMenu?.some((item) => item.QuickId === 'AMC002');
  const isBookingVisible = amcMenu?.some((item) => item.QuickId === 'EXPBKBOOKING');
  const isVerificationVisible = amcMenu?.some((item) => item.QuickId === 'EXPBKVERIFICATION');
  const isConfirmationVisible = amcMenu?.some((item) => item.QuickId === 'EXPBKCONFIRMATION');
  const isAdminOrSuperadmin = vLoginData?.Admin === 'Y' || vLoginData?.Superadmin === 'Y';

  const showAmcFollowupMenu = isAmcFollowupVisible || isAdminOrSuperadmin;

  const handleToggleMenu = (menuId) => {
    setOpenMenuId((prevId) => (prevId === menuId ? '' : menuId));
  };

  const SideMenu = [
    {
      Name: 'Home',
      Id: 'home',
      route: '/home',
      isVisible:true,
      icon: <HomeIcon />,
      showRoute: true,
      submenu: []
    },
    {
      Name: 'My Work',
      Id: 'myWork',
      route: '/myWork',
      isVisible: true,
      icon: <WorkIcon />,
      showRoute: true,
      submenu: []
    },
    {
      Name: 'Lead Project',
      Id: 'myLeads',
      route: '',
      isVisible: vKern?.Limited_Gravity_Task !== 'Y',
      icon: <AccountTreeIcon />,
      showRoute: true,
      submenu: [
        {
          Name: 'Lead',
          Id: 'Stage01',
          route: '/project',
          active: true,
          handle: () => {
            navigate('/project');
            onClose();
          },
          showRoute: true
        },
        {
          Name: 'Confirmation',
          Id: 'Stage02',
          route: '/lead-Stage?ID=Stage02',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage02');
            onClose();
          },
          showRoute: true
        },
        {
          Name: 'Stage1 Payment',
          Id: 'Stage03',
          route: '/lead-Stage?ID=Stage03',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage03');
            onClose();
          },
          showRoute: true
        },
        {
          Name: 'Installation',
          Id: 'Stage04',
          route: '/lead-Stage?ID=Stage04',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage04');
            onClose();
          },
          showRoute:
            vLoginData.userTaskType === 'Implementation' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Configuration',
          Id: 'Stage05',
          route: '/lead-Stage?ID=Stage05',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage05');
            onClose();
          },
          showRoute:
            vLoginData.userTaskType === 'Implementation' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Data Migration',
          Id: 'Stage06',
          route: '/lead-Stage?ID=Stage06',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage06');
            onClose();
          },
          showRoute:
            vLoginData.userTaskType === 'Implementation' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Training',
          Id: 'Stage07',
          route: '/lead-Stage?ID=Stage07',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage07');
            onClose();
          },
          showRoute: vLoginData.userTaskType === 'RM' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Post Training',
          Id: 'Stage08',
          route: '/lead-Stage?ID=Stage08',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage08');
            onClose();
          },
          showRoute: vLoginData.userTaskType === 'RM' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Final Data Migration',
          Id: 'Stage09',
          route: '/lead-Stage?ID=Stage09',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage09');
            onClose();
          },
          showRoute: vLoginData.userTaskType === 'RM' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Stage2 Payment',
          Id: 'Stage10',
          route: '/lead-Stage?ID=Stage10',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage10');
            onClose();
          },
          showRoute: vLoginData.userTaskType === 'RM' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Live',
          Id: 'Stage11',
          route: '/lead-Stage?ID=Stage11',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage11');
            onClose();
          },
          showRoute: vLoginData.userTaskType === 'RM' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Post Support',
          Id: 'Stage12',
          route: '/lead-Stage?ID=Stage12',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage12');
            onClose();
          },
          showRoute: vLoginData.userTaskType === 'RM' || vLoginData.userTaskType === 'Admin'
        },
        {
          Name: 'Project Close',
          Id: 'Stage13',
          route: '/lead-Stage?ID=Stage13',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage13');
            onClose();
          },
          showRoute:
            vLoginData.userTaskType === 'RM' ||
            vLoginData.userTaskType === 'Admin' ||
            vLoginData.userTaskType === 'Sales Co-ordinator'
        },
        {
          Name: 'Stage3 Payment',
          Id: 'Stage14',
          route: '/lead-Stage?ID=Stage14',
          active: true,
          handle: () => {
            navigate('/lead-Stage?ID=Stage14');
            onClose();
          },
          showRoute: vLoginData.userTaskType === 'RM' || vLoginData.userTaskType === 'Admin'
        }
      ]
    },
    {
      Name: 'Activity',
      Id: 'activity',
      route: '/acitivitySummary',
      isVisible:true,
      icon: <LocalActivityIcon />,
      showRoute: true,
      submenu: []
    },
    {
      Name: 'Enhancement',
      Id: 'enhancement',
      route: '/software-management',
      isVisible: vKern?.Limited_Gravity_Task !== 'Y',
      icon: <ManageAccountsIcon />,
      showRoute: true,
      submenu: []
    },
    {
      Name: 'HeatMap',
      Id: 'heatMap',
      route: '/heatMap',
      isVisible:true,
      icon: <PersonPinCircleIcon />,
      showRoute: true,
      submenu: []
    },
    {
      Name: 'Client Visit',
      Id: 'ClientVisit',
      route: '/client-visit',
      isVisible: vKern?.Limited_Gravity_Task !== 'Y',
      icon: <SupervisedUserCircleIcon />,
      showRoute: true,
      submenu: []
    },
    {
      Name: 'AMC-Followup',
      Id: 'AMCFollowup',
      route: '/AMC-Followup',
      isVisible: vKern?.Limited_Gravity_Task !== 'Y',
      icon: <TaskIcon />,
      showRoute: showAmcFollowupMenu,
      submenu: []
    },
    {
      Name: 'Software Update',
      Id: 'softwareUpdate',
      route: '/softwareUpdate',
      isVisible: vKern?.Limited_Gravity_Task !== 'Y',
      icon: <WebhookIcon />,
      showRoute:
        vLoginData.userTaskType === 'Implementation' || vLoginData.userTaskType === 'Admin',
      submenu: [
        {
          Name: 'Master',
          route: '/softwareUpdate',
          active: true,
          handle: () => {
            navigate('/softwareUpdate');
            onClose();
          },
          showRoute: isAdminOrSuperadmin
        },
        {
          Name: 'Transaction',
          route: '/softwareUpdateTrans',
          active: true,
          handle: () => {
            navigate('/softwareUpdateTrans');
            onClose();
          },
          showRoute: true
        }
      ]
    },
    {
      Name: 'Expenses',
      Id: 'expenseBooking',
      route: '/expenseBooking',
      isVisible: true,
      icon: <StyleIcon />,
      showRoute: true || vKern?.Limited_Gravity_Task === 'Y',
      submenu: [
        {
          Name: 'Booking',
          route: '/expenseBooking',
          active: true,
          handle: () => {
            navigate('/expenseBooking');
            onClose();
          },
          showRoute: vKern?.Limited_Gravity_Task !== 'Y' || isBookingVisible
        },
        {
          Name: 'Verification',
          route: '/bookingVerify',
          active: true,
          handle: () => {
            navigate('/bookingVerify');
            onClose();
          },
          showRoute:
            vLoginData.userTaskType === 'Admin' ||
            isVerificationVisible ||
            vKern?.Limited_Gravity_Task === 'Y'
        },
        {
          Name: 'Confirmation',
          route: '/bookingConfirmed',
          active: true,
          handle: () => {
            navigate('/bookingConfirmed');
            onClose();
          },
          showRoute:
            vLoginData.userTaskType === 'Sales Co-ordinator' ||
            isConfirmationVisible ||
            (vLoginData?.Superadmin === 'Y' && vKern?.Limited_Gravity_Task !== 'Y')
        }
      ]
    },
     {
      Name: 'Daily Report',
      Id: 'DailyReportF',
      route: '/dailyReport',
      isVisible: true,
      icon: <AssessmentIcon />,
      showRoute: true,
      submenu: []
    },
    
  ];

  return (
    <List className="sidemenu">
      {SideMenu.filter((menu) => menu.isVisible && menu.showRoute).map((menu) => (
        <React.Fragment key={menu.Id}>
          <ListItemButton
            onClick={() => {
              if (menu.submenu?.length > 0) {
                handleToggleMenu(menu.Id);
              } else {
                setOpenMenuId('');
                navigate(menu.route);
                onClose();
              }
            }}>
            <ListItemIcon>{menu.icon}</ListItemIcon>
            <ListItemText primary={menu.Name} />
            {menu.submenu?.length > 0 &&
              (openMenuId === menu.Id ? (
                <ExpandLessIcon sx={{ color: '#0000008a' }} />
              ) : (
                <ExpandMoreIcon sx={{ color: '#0000008a' }} />
              ))}
          </ListItemButton>

          {/* Submenu collapse */}
          {menu.submenu?.length > 0 && (
            <Collapse in={openMenuId === menu.Id} timeout="auto" unmountOnExit className="submenu">
              {menu.submenu.map(
                (sub) =>
                  sub.showRoute && (
                    <div
                      key={sub.Id}
                      style={{
                        marginLeft: '26px',
                        borderLeft: '3px solid #0000008a'
                      }}>
                      <ListItemButton onClick={eval(sub.handle)}>
                        <ListItemIcon>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <ListItemText primary={sub.Name} />
                      </ListItemButton>
                    </div>
                  )
              )}
            </Collapse>
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default SideMenus;
